<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <span style="width: 100%">
          Edit Template
          <v-btn class="primary lighten-1 float-right" dark icon @click="$emit('cancel'); reset()">
            <v-icon color="white--text">mdi-close</v-icon>
          </v-btn>
        </span>
      </v-card-title>

      <v-card-text class="pa-5 mt-2">
        <v-banner single-line v-model="show" class="green--text pa-0 subtitle-2">Template updated!</v-banner>

        <v-text-field
          label="Subject"
          outlined
          v-model="template.templateSubject"
          :success="success"
        ></v-text-field>
        <v-text-field
          label="Name"
          outlined
          v-model="template.name"
          :success="success"
        ></v-text-field>
        <div class="d-flex my-1">
          <v-select
            :items="stageItems"
            label="Stage"
            outlined
            :success="success"
            v-model="template.stage"
          ></v-select>
        </div>
        <v-textarea
          outlined
          label="Message"
          counter
          v-model="template.template"
          hide-details
          :success="success"
        ></v-textarea>
        <div class="d-flex my-1">
          <v-radio-group v-model="template.mode" row>
            <v-radio label="SMS" value="false" class="mr-10" hide-details color="primary"></v-radio>
            <v-radio label="Email" value="true" hide-details color="primary"></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>

      <v-divider class="primary ma-auto" width="91%"></v-divider>

      <v-card-actions class="py-5 px-5">
        <div class="flex-grow-1"></div>
        <v-btn class="primary" v-if="!add" dark text @click="update()" :disabled="disable">Update</v-btn>
        <v-btn class="primary" v-if="add" dark text @click="submit()" :disabled="disable">Submit</v-btn>
        <v-btn class="primary" dark text @click="$emit('cancel')" :disabled="disable">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="loadingDialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pt-3 white--text">
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "TemplateDialog",
  data: () => ({
    success: false,
    show: false,
    loadingDialog: false,
    disable: false,
    stageItems: ["Courtesy","Reminder 1", "Reminder 2", "Reminder 3", "Restrict Notice"]
    // rules: [v => v.length <= 181 || 'Max 181 characters'],
  }),
  props: {
    dialog: { type: Boolean },
    template: { type: Object },
    add: {type: Boolean}
  },
  methods: {
    ...mapActions('template', ['updateTemplate','addTemplate']),
    update () {
      this.loadingDialog = true
      this.template.emailOrSMS = this.template.mode
      this.updateTemplate(this.template).then(data => {
        if (data.length != 0) {
          setTimeout(() => {
            this.show = true
            this.success = true
            this.loadingDialog = false
            this.disable = true
          }, 500);
        } else {
          this.error = true
        }
      })
    },
    submit() {
      this.loadingDialog = true;
      this.template.emailOrSMS = this.template.mode;
      //todo validate values
      this.addTemplate(this.template).then(data => {
        if (data.length != 0) {
          setTimeout(() => {
            this.show = true
            this.success = true
            this.loadingDialog = false
            this.disable = true
          }, 500);
        } else {
          this.error = true
        }
      })
    },
    reset () {
      this.success = false
      this.show = false
      this.disable = false
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-banner__wrapper {
  padding: 0 0 15px !important;
}
</style>
